import { SignedIn, SignedOut, SignInButton, UserButton } from "@clerk/clerk-react";

export function HomeRoute() {
  return (
    <main className="shell">
      <section className="card">
        <p className="eyebrow">CCLP Acquisitions Agent</p>
        <h1>Authorize agents and manage your active connections.</h1>
        <p>
          This site is the sign-in surface for the CCLP Acquisitions Internal
          Team Orchestrator. You'll usually arrive here from your AI client
          (Claude Desktop, Claude Code, or Cowork) when authorizing a new
          connection to the acquisitions tools.
        </p>
        <div style={{ marginTop: 24 }}>
          <SignedOut>
            <SignInButton mode="modal">
              <button className="primary">Sign in</button>
            </SignInButton>
          </SignedOut>
          <SignedIn>
            <p className="hint">Signed in.</p>
            <UserButton />
            <p className="hint" style={{ marginTop: 16 }}>
              <a href="/connections">Manage active connections →</a>
            </p>
          </SignedIn>
        </div>
      </section>
    </main>
  );
}
